import { render, staticRenderFns } from "./institution.vue?vue&type=template&id=6846285d&"
import script from "./institution.vue?vue&type=script&lang=js&"
export * from "./institution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports